const CARDS = [
  {
    img: 'https://readdy.ai/api/search-image?query=Action%20movie%20fight%20scene%20in%20urban%20rooftop%2C%20dramatic%20cinematic%20lighting%2C%20warm%20golden%20sunset%20sky%2C%20Hollywood%20style%2C%20intense%20atmosphere%2C%20no%20text&width=600&height=340&seq=card-01&orientation=landscape',
    title: '绝地追击',
    category: '动作冒险',
    desc: '硬汉特工孤身对抗国际犯罪集团，全程高能无尿点',
    rating: '9.2',
    views: '128万',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Romantic%20couple%20dancing%20in%20rain%20under%20street%20lamp%2C%20warm%20romantic%20cinematic%20lighting%2C%20K-drama%20aesthetic%2C%20emotional%20mood%2C%20no%20text&width=600&height=340&seq=card-02&orientation=landscape',
    title: '雨季恋人',
    category: '爱情文艺',
    desc: '一段跨越十年的感人爱情故事，催泪指数满分',
    rating: '8.9',
    views: '96万',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20cyberpunk%20city%20with%20flying%20cars%20and%20neon%20lights%2C%20sci-fi%20cinematic%20atmosphere%2C%20blade%20runner%20style%2C%20dark%20futuristic%20mood%2C%20no%20text&width=600&height=340&seq=card-03&orientation=landscape',
    title: '赛博之城2077',
    category: '科幻动作',
    desc: '赛博朋克世界观下的惊险冒险，视觉特效炸裂',
    rating: '9.0',
    views: '156万',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Comedy%20scene%20with%20friends%20laughing%20at%20dinner%20party%2C%20warm%20cozy%20lighting%2C%20sitcom%20style%2C%20happy%20atmosphere%2C%20casual%20cinematic%20photography%2C%20no%20text&width=600&height=340&seq=card-04&orientation=landscape',
    title: '欢乐一家人',
    category: '喜剧温情',
    desc: '三代同堂的爆笑日常，治愈系家庭喜剧天花板',
    rating: '8.7',
    views: '89万',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Horror%20scene%20with%20foggy%20forest%20and%20full%20moon%2C%20eerie%20cinematic%20atmosphere%2C%20dark%20moody%20lighting%2C%20suspenseful%20horror%20movie%20style%2C%20mysterious%20shadows%2C%20no%20text&width=600&height=340&seq=card-05&orientation=landscape',
    title: '迷雾森林',
    category: '惊悚恐怖',
    desc: '深山老林中的恐怖秘密，每一声脚步都让人窒息',
    rating: '8.5',
    views: '73万',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Historical%20documentary%20scene%20with%20ancient%20Chinese%20palace%2C%20warm%20golden%20light%2C%20cultural%20heritage%20atmosphere%2C%20cinematic%20documentary%20photography%2C%20majestic%20architecture%2C%20no%20text&width=600&height=340&seq=card-06&orientation=landscape',
    title: '文明之光',
    category: '纪录人文',
    desc: '探寻中华五千年文明瑰宝，每一帧都是壁纸',
    rating: '9.4',
    views: '45万',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20school%20rooftop%20scene%20with%20cherry%20blossoms%2C%20warm%20sunset%20lighting%2C%20emotional%20atmosphere%2C%20beautiful%20anime%20background%20art%2C%20cinematic%20composition%2C%20no%20text&width=600&height=340&seq=card-07&orientation=landscape',
    title: '樱花季的约定',
    category: '动漫剧场',
    desc: '青春校园纯爱物语，樱花纷飞中的唯美邂逅',
    rating: '9.1',
    views: '112万',
  },
];

export default function SectionCards() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50">精选内容</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-400 max-w-xl mx-auto">
            编辑精选高分影视，每一部都值得细细品味
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {CARDS.map((card, i) => (
            <div
              key={i}
              className="group rounded-xl overflow-hidden bg-background-100 border border-background-300/30 hover:border-primary-500/30 transition-all duration-200 cursor-pointer"
            >
              <div className="relative w-full h-40 md:h-44 overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3 px-2 py-0.5 text-[10px] font-medium rounded-md bg-background-900/80 text-background-50 whitespace-nowrap">
                  {card.category}
                </div>
                <div className="absolute top-3 right-3 px-2 py-0.5 text-[10px] font-bold rounded-md bg-primary-500 text-background-950 whitespace-nowrap">
                  {card.rating}
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm font-semibold text-foreground-100 truncate">{card.title}</h3>
                <p className="mt-1 text-xs text-foreground-500 line-clamp-2 leading-relaxed">{card.desc}</p>
                <div className="flex items-center gap-2 mt-3 text-[10px] text-foreground-600">
                  <i className="ri-eye-line"></i>
                  <span>{card.views} 次播放</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}